import {
  createRouter,
  createWebHashHistory,
  NavigationGuardNext,
  RouteLocationNormalized
} from "vue-router";
import { handleAccess, handleUserAuthRedirect } from "./middleware";
import { Component } from "vue";
import Home from "../../infrastructure/presentation/views/LandingPage.vue";
import HomeCirculo from "../../infrastructure/presentation/views/LandingPageCirculo.vue";
import HomeGTop from "../../infrastructure/presentation/views/LandingPageGTop.vue";
import store from "../../infrastructure/repository/store/store";
import { Configuration } from "../../domain/entities/configuration";

let home;
let term;
if (process.env.VUE_APP_THEME === "circulo") {
  home = {
    path: "/home/:resetPass?/:resetBy?/:token?",
    name: "home",
    component: HomeCirculo,
    meta: {
      isPublic: true
    }
  };
  term = {
    path: "/terms",
    name: "terms",
    meta: {
      isPublic: true
    },
    component: () =>
      import("../../infrastructure/presentation/CirculoTerms.vue")
  };
} else if (process.env.VUE_APP_THEME === "gtop") {
  home = {
    path: "/home/:resetPass?/:resetBy?/:token?",
    name: "home",
    component: HomeGTop,
    meta: {
      isPublic: true
    }
  };
  term = {
    path: "/terms",
    name: "terms",
    meta: {
      isPublic: true
    },
    component: () => import("../../infrastructure/presentation/Terms.vue")
  };
} else {
  home = {
    path: "/home/:resetPass?/:resetBy?/:token?",
    name: "home",
    component: Home,
    meta: {
      isPublic: true
    }
  };
  term = {
    path: "/terms",
    name: "terms",
    meta: {
      isPublic: true
    },
    component: () => import("../../infrastructure/presentation/Terms.vue")
  };
}

const routes = [
  /* Redirect to the landing page if it's an empty path. */
  {
    path: "",
    redirect: { name: "dashboard" }
  },
  /* Redirect to the 404 page when the path couldn't be found or doesn't exist. */
  {
    path: "/:pathMatch(.*)*",
    component: () => import("../../infrastructure/presentation/views/404.vue")
  },
  /* Landing page */
  home,
  /* Terms of use and privacy policy */
  term,
  /* The actual application */
  {
    path: "",
    component: () =>
      import(
        "../../infrastructure/presentation/components/application/moldure/Moldure.vue"
      ),
    meta: {
      breadcrumbText: "dashboard",
      isPublic: true
    },
    children: [
      /* Dashboard router view */
      {
        path: "dashboard",
        beforeEnter: handleAccess,
        component: () =>
          import("../../infrastructure/presentation/views/RouterView.vue"),
        meta: {
          isPublic: false
        },
        children: [
          /* Dashboard */
          {
            path: "",
            name: "dashboard",
            component: () =>
              import("../../infrastructure/presentation/views/Dashboard.vue")
          },
          {
            path: "onboarding/:step",
            name: "onboarding",
            component: () =>
              import("../../infrastructure/presentation/views/Dashboard.vue")
          },
          {
            path: "statistics/:option?",
            name: "statistics",
            component: (): Promise<Component> =>
              import(
                "../../infrastructure/presentation/views/UserStatistics.vue"
              )
          },
          {
            path: "/maintenance",
            name: "maintenance",
            component: () =>
              import("../../infrastructure/presentation/views/Maintenance.vue")
          },
          {
            path: "interest/:interest_id",
            name: "interest",
            component: () =>
              import(
                "../../infrastructure/presentation/components/application/interest/InterestTraining.vue"
              )
          },
          {
            /* Course router view */
            path: "course/:course_id",
            props: true,
            meta: {
              breadcrumbText: "treinamento"
            },
            component: () =>
              import("../../infrastructure/presentation/views/RouterView.vue"),
            children: [
              /* Course */
              {
                path: "",
                name: "course",
                component: () =>
                  import(
                    "../../infrastructure/presentation/views/course/Course.vue"
                  )
              },
              /* Content router view */
              {
                path: "content/:content_id",
                props: true,
                component: () =>
                  import(
                    "../../infrastructure/presentation/views/RouterView.vue"
                  ),
                children: [
                  /* Content */
                  {
                    path: "",
                    name: "course_content",
                    component: () =>
                      import(
                        "../../infrastructure/presentation/views/content/ContentView.vue"
                      )
                  },
                  /* Exercise */

                  {
                    path: "questionnaire/:questionnaire_id/page/:page",
                    name: "course_questionnaire",
                    props: true,
                    component: () =>
                      import(
                        "../../infrastructure/presentation/views/content/ContentView.vue"
                      )
                  },
                  {
                    path: "user-responses/:questionnaireId",
                    name: "user_responses",
                    props: true,
                    component: () =>
                      import("../../infrastructure/presentation/views/content/ContentView.vue")
                  }
                ]
              },
            ]
          },
          {
            /* Event router view */
            path: "event/:event_id/class/:class_id",
            props: true,
            meta: {
              breadcrumbText: "evento"
            },
            component: () =>
              import("../../infrastructure/presentation/views/RouterView.vue"),
            children: [
              /* Event */
              {
                path: "",
                name: "event",
                component: () =>
                  import(
                    "../../infrastructure/presentation/views/course/EventCourse.vue"
                  )
              },
              /* Content */
              {
                path: "content/:content_id",
                component: () =>
                  import(
                    "../../infrastructure/presentation/views/RouterView.vue"
                  ),
                children: [
                  {
                    path: "",
                    name: "event_content",
                    component: () =>
                      import(
                        "../../infrastructure/presentation/views/content/ContentView.vue"
                      )
                  },
                  /* Exercise */
                  {
                    path: "questionnaire/:questionnaire_id/page/:page",
                    name: "event_questionnaire",
                    props: true,
                    component: () =>
                      import(
                        "../../infrastructure/presentation/views/content/ContentView.vue"
                      )
                  },
                ]
              }
            ]
          },
          {
            /* Training course router view */
            path: "training-course/:trainingCourseID",
            props: true,
            meta: {
              breadcrumbText: "evento"
            },
            component: () =>
              import("../../infrastructure/presentation/views/RouterView.vue"),
            children: [
              /* Event */
              {
                path: "",
                name: "training-course",
                component: () =>
                  import(
                    "../../infrastructure/presentation/views/course/TrainingCourse.vue"
                  )
              }
            ]
          }
        ]
      },
      {
        path: "interest/:interest_id",
        name: "interest",
        component: () =>
          import(
            "../../infrastructure/presentation/components/application/interest/InterestTraining.vue"
            )
      },
      /* Search view */
      {
        path: "/search",
        component: () =>
          import("../../infrastructure/presentation/views/RouterView.vue"),
        meta: {
          isPublic: false
        },
        children: [
          {
            path: "",
            name: "global_search",
            component: () =>
              import("../../infrastructure/presentation/views/SearchView.vue")
          }
        ]
      },
      {
        path: "/details-course-tracks/:entityID?",
        props: true,
        component: () =>
          import("../../infrastructure/presentation/views/RouterView.vue"),
        meta: {
          isPublic: false
        },
        children: [
          {
            path: "",
            name: "details_course_tracks",
            component: () =>
              import(
                "../../infrastructure/presentation/views/SearchSchools.vue"
              )
          }
        ]
      },
      {
        path: "/details-courses/:entityID?",
        props: true,
        component: () =>
          import("../../infrastructure/presentation/views/RouterView.vue"),
        meta: {
          isPublic: false
        },
        children: [
          {
            path: "",
            name: "details_courses",
            component: () =>
              import(
                "../../infrastructure/presentation/views/SearchCourseTrack.vue"
              )
          }
        ]
      },
      {
        path: "/details-courses-instructors/:entityID?",
        props: true,
        component: () =>
          import("../../infrastructure/presentation/views/RouterView.vue"),
        meta: {
          isPublic: false
        },
        children: [
          {
            path: "",
            name: "details_courses_instructors",
            component: () =>
              import(
                "../../infrastructure/presentation/views/SearchInstructorsCourses.vue"
              )
          }
        ]
      },
      {
        path: "/shop/page/:productsPage?",
        component: () =>
          import("../../infrastructure/presentation/views/RouterView.vue"),
        meta: {
          isPublic: false
        },
        children: [
          /* Shop */
          {
            path: "",
            name: "shop",
            beforeEnter: async (
              to: RouteLocationNormalized,
              from: RouteLocationNormalized,
              next: NavigationGuardNext
            ): Promise<void> => {
              if (!to.params.productsPage) {
                await router.push({
                  name: "shop",
                  params: { productsPage: "1" }
                });
              }
              next();
            },
            component: () =>
              import("../../infrastructure/presentation/views/shop/Shop.vue")
          },
          {
            path: "bag/:orderID?",
            name: "bag",
            component: () =>
              import("../../infrastructure/presentation/views/shop/Bag.vue")
          },
          {
            path: "favorites",
            name: "favorite",
            beforeEnter: async (
              to: RouteLocationNormalized,
              from: RouteLocationNormalized,
              next: NavigationGuardNext
            ): Promise<void> => {
              if (!to.query.page) {
                await router.push({
                  name: "favorite",
                  query: { page: 1 }
                });
              }
              next();
            },
            component: () =>
              import(
                "../../infrastructure/presentation/views/shop/FavoriteList.vue"
              )
          },
          {
            path: "product/:productID?",
            name: "product_detail",
            component: () =>
              import(
                "../../infrastructure/presentation/views/shop/ProductDetail.vue"
              )
          }
        ]
      },

      /** Profile router view */
      {
        path: "profile/:option?",
        component: () =>
          import("../../infrastructure/presentation/views/RouterView.vue"),
        meta: {
          isPublic: false
        },
        children: [
          /* Profile */
          {
            path: "",
            name: "profile",
            component: () =>
              import("../../infrastructure/presentation/views/Profile.vue")
          },

          /* Edit profile */
          {
            path: "edit",
            name: "edit",
            component: () =>
              import("../../infrastructure/presentation/views/EditProfile.vue")
          },

          {
            path: "statement",
            name: "statement",
            component: () =>
              import(
                "../../infrastructure/presentation/views/DecoinExtract.vue"
              )
          }
        ]
      },
    ]
  },
];

const router = createRouter({
  history: createWebHashHistory("/student/"),
  routes
});

router.beforeEach(async (routeTo, routeFrom, next) => {
  const isPublicRoute = routeTo.meta?.isPublic;

  if (!isPublicRoute && routeTo.name !== "maintenance") {
    try {
      await store.dispatch("configuration_module/get");
    } catch (e) {
      console.error(e);
    }
  }

  const config: Configuration =
    store.getters["configuration_module/configuration"];
  const isMaintenanceMode = config.isMaintenanceMode;

  if (isMaintenanceMode && routeTo.name !== "maintenance") {
    return next({ name: "maintenance" });
  }

  if (!isMaintenanceMode && routeTo.name === "maintenance") {
    return next({ name: "dashboard" });
  }

  await handleUserAuthRedirect(routeTo, routeFrom, next, router);
});

export default router;
